import v from './Variables';

function backgroundColors() {
  let styles = '';

  Object.keys(v.colors).forEach((key) => {
    styles += `
       .bg--${key} {

         background: ${(v.colors as any)[key]} !important;
       }
     `;
  });

  return styles;
}

export default backgroundColors;
